import {load} from '@shopify/theme-sections';
import '../sections/product';
import '../../styles/templates/index.scss';
import {lazyScript} from '../ui/lazy-script';

lazyScript();

load('*');
